/* ----- Widget Types ------ */
export const WIDGET_ALPHABET = 'WIDGET_ALPHABET'
export const WIDGET_APPS = 'WIDGET_APPS'
export const WIDGET_CONTACT = 'WIDGET_CONTACT'
export const WIDGET_GALLERY = 'WIDGET_GALLERY'
export const WIDGET_IFRAME = 'WIDGET_IFRAME'
export const WIDGET_IMAGE = 'WIDGET_IMAGE'
export const WIDGET_KEYBOARDS = 'WIDGET_KEYBOARDS'
export const WIDGET_LOGO = 'WIDGET_LOGO'
export const WIDGET_LIST = 'WIDGET_LIST'
export const WIDGET_QUOTES = 'WIDGET_QUOTES'
export const WIDGET_STATS = 'WIDGET_STATS'
export const WIDGET_TEXT = 'WIDGET_TEXT'
export const WIDGET_TEXTCONCISE = 'WIDGET_TEXTCONCISE'
export const WIDGET_TEXTFULL = 'WIDGET_TEXTFULL'
export const WIDGET_VIDEO = 'WIDGET_VIDEO'
export const WIDGET_WOTD = 'WIDGET_WOTD'

/* ---- Widget Format Options ---- */
export const FORMAT_DEFAULT = 'Default'
export const FORMAT_LEFT = 'Left'
export const FORMAT_RIGHT = 'Right'

/* ---- Widget Setting Keys ---- */
export const SETTING_WYSIWYG = 'textWithFormatting'
export const SETTING_AUDIO = 'audio'
export const SETTING_IMAGE = 'image'
